import { Directive, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, Validator } from '@angular/forms';

@Directive({
  selector: '[ipSharedRequiredValue]',
  standalone: true,
  providers: [{ provide: NG_VALIDATORS, useExisting: RequiredValueValidator, multi: true }],
})
export class RequiredValueValidator implements Validator {
  @Input('ipSharedRequiredValue') required!: boolean;

  validate(control: AbstractControl): { requiredValue: true } | null {
    return this.required ? (control.value ? null : { requiredValue: true }) : null;
  }
}
